import React from "react";
import { Link } from "react-router-dom";

/** A card in the lessons list. */
export default function LessonCard({ lesson }) {
  return (
    <Link
      to={`/articles/lesson/${lesson.slug}`}
      className="group block rounded-xl border border-slate-800 bg-slate-900/40 p-5 transition hover:border-sky-500/40 hover:bg-slate-900/80"
    >
      {lesson.has_audio && (
        <div className="mb-2 flex items-center gap-2">
          <span className="rounded bg-sky-500/15 px-2 py-0.5 text-xs text-sky-300">
            ♪ audio
          </span>
        </div>
      )}
      <h3 className="mb-1 text-lg font-semibold text-slate-100 transition group-hover:text-sky-300">
        {lesson.title}
      </h3>
      <p className="line-clamp-3 text-sm text-slate-400">{lesson.caption}</p>
    </Link>
  );
}
